import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { MODALS } from "components/common/Modal/utils";
import { destroyModal, initModal, toggleModal } from "actions/modal";

const useModal = ({ modalId, initialData = {} }) => {
  const dispatch = useDispatch();

  const { open = false, data } = useSelector(
    (state) => state.modal.modals[modalId] || initialData
  );

  useEffect(() => {
    dispatch(initModal({ modalId, initialData }));
    return () => {
      dispatch(destroyModal({ modalId }));
    };
  }, []);

  const handleClose = () => {
    dispatch(toggleModal({ modalId, open: false }));
  };

  return [open, data, handleClose];
};

useModal.propTypes = {
  modalId: PropTypes.oneOf(Object.keys(MODALS)).isRequired,
  initialData: PropTypes.object,
};

export default useModal;
